import {ActionTree} from "vuex";
import {BalanceFilter, FinanceState, OverdraftFilter} from "@/store/finance/types";
import {RootState} from "@/store/types";
import axios, {AxiosResponse} from "axios";

export const actions: ActionTree<FinanceState, RootState> = {
  getBalances: async ({commit, dispatch}, data: BalanceFilter) => {
    try {
      let resp: AxiosResponse = await axios({url: '/lk-api/finance/balances/topups', params: data});
      commit('setBalances', resp.data);
      return resp.data;
    } catch (err) {
      throw err;
    }
  },
  getOverdrafts: async ({commit, dispatch}, data: OverdraftFilter) => {
    try {
      let resp: AxiosResponse = await axios({url: '/lk-api/finance/balances', params: data});
      commit('setOverdrafts', resp.data);
      return resp.data;
    } catch (err) {
      throw err;
    }
  },
  putBalance: async ({commit, dispatch}, data: any) => {
    try {
      let resp: AxiosResponse = await axios({
        method: 'put',
        url: `/lk-api/finance/balances/${data.id}/balance`,
        data: data.item
      });
      console.log(resp.data);
      await dispatch('getBalances');
      return resp.data;
    } catch (err) {
      throw err;
    }
  },
  putOverdraft: async ({commit, dispatch}, data: any) => {
    try {
      let resp: AxiosResponse = await axios({
        method: 'put',
        url: `/lk-api/finance/balances/${data.id}/overdraft`,
        data: data.item
      });
      console.log(resp.data);
      await dispatch('getOverdrafts');
      return resp.data;
    } catch (err) {
      throw err;
    }
  },
  getPaymentAggregators: async ({commit, dispatch}, data) => {
    try {
      let resp: AxiosResponse = await axios({url: '/lk-api/finance/payment_aggregators', params: data});
      return resp.data?.aggregators;
    } catch (err) {
      throw err;
    }
  },
  paymentSession: async ({commit, dispatch}, data: any) => {
    try {
      let resp: AxiosResponse = await axios({
        method: 'post',
        url: `/lk-api/finance/stripe_session`,
        data
      });
      return resp.data;
    } catch (err) {
      throw err;
    }
  },
}